import React, { useState, useEffect } from 'react';
import './filters.css';
import { useDispatch, useSelector } from "react-redux";
import FilterSelect from "../FilterSelect/FilterSelect";
import { filtersAction } from "../../redux/actions";
import { getBookingSagaAction } from "../../redux/sagaActions";

const Filters = () => {
    const dispatch = useDispatch();
    const filters = useSelector(state => state.filters);
    const booking = useSelector(state => state.booking);

    // Локальный дропдаун
    const [dropdown, setDropdown] = useState(null);

    // Обработчик клика
    const clickHandler = event => {
        if (!event.target.closest('.select')) {
            setDropdown(null);
        }
    };

    useEffect(() => {
        document.addEventListener('click', clickHandler);

        return () => document.removeEventListener('click', clickHandler);
    }, [dropdown]);

    return (
        <div className="filters">
            <div className="form__header">
                <div className="form__close" onClick={ () => dispatch(filtersAction({ ...filters, open: false })) }/>
                <div className="form__title">Фильтры</div>
            </div>
            <div className="filters__wrapper">
                <FilterSelect
                    options={ filters.coaches }
                    handler={ coach_id => {
                        let copyCoaches = filters.coaches.map(elem => {

                            if (elem.id === coach_id) {
                                return { ...elem, active: !elem.active };
                            }
                            else {
                                return elem;
                            }
                        });

                        dispatch(filtersAction({
                            ...filters,
                            coaches: copyCoaches
                        }));
                    } }
                    placeholder={ 'Укажите тренера' }
                    open={ dropdown === 'coach' }
                    openHandler={ () => setDropdown(dropdown !== null ? null : 'coach') }
                    clear={ () => {
                        dispatch(filtersAction({
                            ...filters,
                            coaches: filters.coaches.map(el => ({ ...el, active: false }))
                        }))
                    } }
                />
                <FilterSelect
                    options={ filters.types }
                    handler={ type_id => {
                        let copyTypes = filters.types.map(elem => {

                            if (elem.id === type_id) {
                                return { ...elem, active: !elem.active };
                            }
                            else {
                                return elem;
                            }
                        });

                        dispatch(filtersAction({
                            ...filters,
                            types: copyTypes
                        }));
                    } }
                    placeholder={ 'Укажите тип занятия' }
                    open={ dropdown === 'type' }
                    openHandler={ () => setDropdown(dropdown !== null ? null : 'type') }
                    clear={ () => {
                        dispatch(filtersAction({
                            ...filters,
                            types: filters.types.map(el => ({ ...el, active: false }))
                        }))
                    } }
                />
                <div className="filters__submit">
                    <div className="button"
                        onClick={ () => {
                            // Запрашиваем записи на групповые занятия
                            dispatch(getBookingSagaAction({ date: booking.date }));
                            // Закрываем окно с фильтрами
                            dispatch(filtersAction({ ...filters, open: false }));
                        } }
                    >Применить</div>
                </div>
            </div>
        </div>
    );
};

export default Filters;